let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("4Z5Uh")]).then(() => parcelRequire('f10rR'));